import { render, staticRenderFns } from "./EnterpriseDetail.vue?vue&type=template&id=72563d17&scoped=true&"
import script from "./EnterpriseDetail.vue?vue&type=script&lang=js&"
export * from "./EnterpriseDetail.vue?vue&type=script&lang=js&"
import style0 from "./EnterpriseDetail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./EnterpriseDetail.vue?vue&type=style&index=1&id=72563d17&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72563d17",
  null
  
)

export default component.exports